const Maps = () => {
    return <><h1>Maps</h1>
    <iframe  title="map" src="/map/1" className="w-screen h-[40vh]"></iframe>
    </>;
  };
  
  export default Maps;